import { render, staticRenderFns } from "./Distribucion.vue?vue&type=template&id=60306ab4&"
import script from "./Distribucion.vue?vue&type=script&lang=js&"
export * from "./Distribucion.vue?vue&type=script&lang=js&"
import style0 from "./Distribucion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports